import { Divider, Stack, Tooltip, Typography } from '@mui/material';

import CopyToClipboardButton from '../buttons/copyToClipboardButton';

export default function CopyableCode({
  title,
  code,
  codeClassName,
  variant,
  tooltipTitle,
  maxHeight,
}: {
  code: string;
  codeClassName?: string;
  title?: string;
  variant?: 'default' | 'error';
  tooltipTitle?: React.ReactNode;
  maxHeight?: string;
}) {
  const color =
    variant === 'error'
      ? 'var(--mui-palette-error-main)'
      : 'var(--mui-palette-text-primary)';
  const bgColorClass =
    variant === 'error'
      ? 'bg-[var(--mui-palette-error-opacity)]'
      : 'bg-gray-100';

  if (title) {
    return (
      <Stack
        className={`w-full p-[16px] ${bgColorClass} rounded-[4px]`}
        sx={{ maxHeight }}
        divider={
          <Divider
            sx={{
              borderStyle: 'dashed',
              borderColor: color,
            }}
          />
        }
        gap='12px'
      >
        <Stack
          direction='row'
          gap='8px'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography variant='subtitle1' fontWeight='bold' color={color}>
            {title}
          </Typography>
          <Stack direction='row' gap='8px' alignItems='center'>
            {tooltipTitle && (
              <Tooltip
                disableInteractive={false}
                className='text-xl'
                title={tooltipTitle}
              >
                <i className='material-symbols-help-outline-rounded'></i>
              </Tooltip>
            )}
            <CopyToClipboardButton
              textToCopy={code}
              className={`text-[${color}]`}
            />
          </Stack>
        </Stack>
        <CodeBlock code={code} className={codeClassName} color={color} />
      </Stack>
    );
  }

  return (
    <Stack
      direction='row'
      gap='8px'
      alignItems='start'
      className={`w-full p-[16px] ${bgColorClass} rounded-[4px]`}
      sx={{ maxHeight }}
    >
      <CodeBlock code={code} className={codeClassName} color={color} />
      <CopyToClipboardButton textToCopy={code} className={`text-[${color}]`} />
    </Stack>
  );
}

const CodeBlock = ({
  code,
  className,
  color,
}: {
  code: string;
  className?: string;
  color: string;
}) => {
  return (
    <code
      className={` break-pretty w-full whitespace-pre overflow-x-auto text-[13px] text-[${
        color
      }] ${className ?? ''}`}
    >
      {code}
    </code>
  );
};
